import { Spacer } from "../atoms/Atoms"
import React from "react"
import styled from "styled-components"
import { IlloIvf } from "../atoms/Illustrations"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { BodySmall } from "../atoms/Bodies"
import L10n from "../../../lib/carrot-l10n"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const HeroText = styled.span`
  font-size: 17px;
  line-height: 1.5em;
`

const ImageDiv = styled.div`
  padding-left: 37px;
`

const ActionNeededForIvfHero = () => (
  <div className="flex flex-auto flex-row">
    <RoundedRectangle padding="pa0" backgroundColor="pearl-lusta">
      <div className="flex flex-row-reverse flex-wrap justify-end">
        <div className="flex w-50 items-center">
          <ImageDiv>
            <IlloIvf className="h-auto" />
          </ImageDiv>
        </div>
        <div className="w-50 flex flex-column flex-grow-1 min-w250px pt4 pb35 pr35 pl4">
          <H2>{l`Action needed`}</H2>
          <Spacer height={1} />
          <BodySmall font="publico-text" color="black-80">
            <HeroText>
              {l`Get started early on additional requirements to unlock your financial benefit for IVF.`}
            </HeroText>
          </BodySmall>
          <Spacer height={2} />
          <ArrowLink to="/reimbursements/ivf-requirements">{l`Take action now`}</ArrowLink>
          <Spacer height={2} />
        </div>
      </div>
    </RoundedRectangle>
  </div>
)

export default ActionNeededForIvfHero
